// Session Status Indicator - Shows session timeout and activity status
import React, { useState, useEffect } from 'react'
import sessionManager from '../lib/sessionManager'

const SessionStatus = () => {
  const [sessionInfo, setSessionInfo] = useState(sessionManager.getSessionInfo())
  const [showStatus, setShowStatus] = useState(false)

  useEffect(() => {
    // Update session info every 30 seconds
    const interval = setInterval(() => {
      const info = sessionManager.getSessionInfo()
      setSessionInfo(info)
      
      // Show warning when less than 5 minutes until timeout
      setShowStatus(info.isActive && info.timeUntilTimeout <= 5 && info.timeUntilTimeout > 0)
    }, 30000)

    return () => clearInterval(interval)
  }, [])

  if (!sessionInfo.isActive || !showStatus) {
    return null
  }

  const handleExtendSession = () => {
    // Trigger activity to extend session
    sessionManager.trackActivity()
    setShowStatus(false)
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-3 shadow-lg max-w-md">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-yellow-800">
              Session Timeout Warning
            </h3>
            <p className="text-sm text-yellow-700 mt-1">
              Your session will expire in {sessionInfo.timeUntilTimeout} minute{sessionInfo.timeUntilTimeout !== 1 ? 's' : ''} due to inactivity.
            </p>
          </div>
          <div className="ml-4 flex-shrink-0">
            <button
              onClick={handleExtendSession}
              className="bg-yellow-100 hover:bg-yellow-200 text-yellow-800 px-3 py-1 rounded text-xs font-medium transition-colors"
            >
              Extend Session
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SessionStatus